"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeValue = encodeValue;
exports.encodeValueGtx = encodeValueGtx;
exports.decodeValue = decodeValue;
exports.decodeValueGtx = decodeValueGtx;
exports.parseValue = parseValue;
exports.createTypedArg = createTypedArg;
const buffer_1 = require("buffer");
const definition_1 = require("../gtv/definition");
const bn_js_1 = require("bn.js");
const errors_1 = require("./errors");
const formatter_1 = require("../formatter");
function encodeValue(rawGtv) {
    return definition_1.rawGTV.encode(createTypedArg(rawGtv));
}
function encodeValueGtx(rawGtx) {
    return encodeValue(rawGtx);
}
function decodeValue(bytes) {
    try {
        const obj = definition_1.rawGTV.decode(bytes);
        return parseValue(obj);
    }
    catch (error) {
        throw new Error(`Invalid GTV data. ${error}`);
    }
}
function decodeValueGtx(bytes) {
    const decodedValue = decodeValue(bytes);
    if (!(0, formatter_1.checkGtxType)(decodedValue)) {
        throw new Error(`Unexpected type of value: ${decodedValue}, expected decoded value to be of type RawGtx`);
    }
    return decodedValue;
}
function parseValue(typedArg) {
    var _a, _b;
    if (typedArg.type === "null") {
        return null;
    }
    else if (typedArg.type === "byteArray") {
        return typedArg.value;
    }
    else if (typedArg.type === "string") {
        return typedArg.value;
    }
    else if (typedArg.type === "integer") {
        return Number(typedArg.value);
    }
    else if (typedArg.type === "array") {
        const arrayValue = typedArg.value;
        return arrayValue.map((item) => parseValue(item));
    }
    else if (typedArg.type === "bigInteger") {
        return BigInt((_b = (_a = typedArg.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "");
    }
    else if (typedArg.type === "dict") {
        const arrayValue = typedArg.value;
        const result = {};
        arrayValue.forEach((pair) => {
            result[pair.name] = parseValue(pair.value);
        });
        return result;
    }
    else {
        throw new errors_1.UnexpectedArgumentTypeError(typedArg);
    }
}
function createTypedArg(value) {
    try {
        if (value == null) {
            return { type: "null", value: null };
        }
        if (buffer_1.Buffer.isBuffer(value)) {
            return { type: "byteArray", value: value };
        }
        if (typeof value === "boolean") {
            return { type: "integer", value: value ? 1 : 0 };
        }
        if (typeof value === "string") {
            return { type: "string", value: value };
        }
        if (typeof value === "number") {
            if (!Number.isInteger(value)) {
                throw Error("User error: Only integers are supported");
            }
            return { type: "integer", value: new bn_js_1.BN(value) };
        }
        if (typeof value === "bigint") {
            return { type: "bigInteger", value: new bn_js_1.BN(value.toString()) };
        }
        if (value.constructor === Array) {
            return {
                type: "array",
                value: value.map(item => createTypedArg(item)),
            };
        }
        if (typeof value === "object") {
            let valueAsDictPair = value;
            if (isDictPairWithStringKey(valueAsDictPair)) {
                valueAsDictPair = sortDictPairByKey(valueAsDictPair);
            }
            return {
                type: "dict",
                value: Object.keys(valueAsDictPair).map(function (key) {
                    return { name: key, value: createTypedArg(valueAsDictPair[key]) };
                }),
            };
        }
    }
    catch (error) {
        const message = value ? value.toString() : "RawGtv";
        throw new Error(`Failed to encode ${message}: ${error}`);
    }
    throw new Error(`value ${value} have unsupported type: ${typeof value}`);
}
function isDictPairWithStringKey(obj) {
    for (const key in obj) {
        if (typeof key !== "string") {
            return false;
        }
    }
    return true;
}
function sortDictPairByKey(dict) {
    const sortedArray = Object.entries(dict).sort(([keyA], [keyB]) => {
        if (keyA < keyB) {
            return -1;
        }
        if (keyA > keyB) {
            return 1;
        }
        return 0;
    });
    const sortedDict = {};
    for (const [key, value] of sortedArray) {
        sortedDict[key] = value;
    }
    return sortedDict;
}
//# sourceMappingURL=serialization.js.map